/**
 * @ Author: Housefolios
 * @ Create Time: 2021-11-22 08:46:15
 * @ Modified by: David Helmick
 * @ Modified time: 2025-04-14 14:34:29
 * @ Description: cards with comp information for card view
 */

import React, { useEffect, useState } from 'react'
import {
  strategyCompImgFluidSx,
  strategyFont16SemiboldSx,
  strategyFont16Sx,
  strategyFullHeight100Sx,
  strategyMarginBottomNeg30Sx,
  strategyMarginTop5Sx,
  strategyMarginTopBottom10Sx,
  strategyPad10Sx,
  strategyPrice26Sx,
  strategySliderWidthSx,
  strategyTextRightSx,
  strategyTransparentCenterSx,
} from '@/housefolios-components/PropertyContainer/CenterPage/Common/strategyDashboardSx'

// Centralized lodash imports - much cleaner!
import {
  includes,
  isEmpty,
  map,
  merge,
  compact,
  slice,
} from '@/utils/lodash'

import Slider1 from 'react-slick'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  Grid,
  Avatar,
  Card,
  CardContent,
  Checkbox,
  Slider,
  Typography,
  IconButton,
  Box,
} from '@mui/material'
import { useTheme } from '@mui/material/styles'

import { UPDATE_COMPPROPERTY } from '@/housefolios-components/PropertyContainer/mutations'
import { GET_COMPPROPERTIES } from '@/housefolios-components/PropertyContainer/queries'
import { DEFAULT_PREFERENCES } from '@/housefolios-components/OrganizationSettings/OrganizationPreferences'
import { useMutation } from '@apollo/client/react'
import withSession from '@/housefolios-components/Session/withSession'
import { compsSoldBadgeSx } from '@/theme/skinSx'
import { compMarkerColor } from '@/housefolios-components/PropertyContainer/CenterPage/compMarkerColors'

var months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]

function SliderArrowNext(props) {
  const { className, onClick } = props
  return (
    <div className={className} onClick={onClick}>
      <FontAwesomeIcon icon={['fas', 'chevron-right']} />
    </div>
  )
}

function SliderArrowPrev(props) {
  const { className, onClick } = props
  return (
    <div className={className} onClick={onClick}>
      <FontAwesomeIcon icon={['fas', 'chevron-left']} />
    </div>
  )
}

function CenterPageCompsCardComponent(props) {
  const { openEdit, comp, property } = props
  const theme = useTheme()
  const isDark = theme.palette.mode === 'dark'
  const cardBg = theme.palette.background.paper
  const metricsBg = isDark ? 'rgba(255, 255, 255, 0.08)' : '#eff2f5'
  const mutedLabel = isDark ? 'rgba(255, 255, 255, 0.6)' : '#949798'
  const valueColor = theme.palette.text.primary

  const activeOrg = property?.portfolio?.organization

  const currencyFormat = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })

  const moneysqftFormat = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })

  const numberFormat = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })

  const widgetsCarousels1B = {
    dots: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
    nextArrow: <SliderArrowNext />,
    prevArrow: <SliderArrowPrev />,
  }

  const [inputAdjustment, setInputAdjustment] = useState(
    comp.priceAdjustment,
  )

  useEffect(() => {
    setInputAdjustment(comp.priceAdjustment)
  }, [comp])

  const [updateCompProperty] = useMutation(UPDATE_COMPPROPERTY)

  const onChangeSlider = (
    event,
    value,
    name,
    updateCompProperty = null,
  ) => {
    setInputAdjustment(value)
    if (updateCompProperty) {
      updateCompProperty({
        variables: {
          id: comp._id,
          compPropertyInput: {
            priceAdjustment: Number(value),
          },
        },
        refetchQueries: [
          {
            query: GET_COMPPROPERTIES,
            variables: { propertyId: property._id },
          },
        ],
      })
    }
  }

  const date = new Date(comp.saleDate)
  let createdAt = new Date(comp.createdAt)
  let createdAtYear = createdAt.getFullYear()
  let createdAtMonth = createdAt.getMonth() + 1
  let createdAtDay = createdAt.getDate()
  createdAt =
    createdAtMonth + '/' + createdAtDay + '/' + createdAtYear

  let createdAt2 = new Date()
  createdAt2.setMonth(createdAt2.getMonth() - 12)

  const renderImageSlide = (imageSrc, imageSmallSrc) => (
    <div
      onClick={(event) => {
        event.stopPropagation()
      }}
    >
      <Card sx={[{
          height: 325,
          backgroundColor: cardBg,
          margin: '1px',
        }, { boxShadow: 'none' }]}>
        <Grid
          container
          direction="column" sx={[strategyFullHeight100Sx, {
            justifyContent: 'center',
          }]}>
          <Grid>
            <Box onClick={props.shared ? null : () => openEdit(comp)} sx={[strategyTransparentCenterSx, {
              position: "relative",
              borderTopLeftRadius: "inherit",
              borderTopRightRadius: "inherit",
              "& .img-wrapper-overlay": {
                width: "100%",
                height: "100%",
                transition: "all 0.2s ease-in-out",
                opacity: 0,
                visibility: "hidden",
                position: "absolute",
                left: 0,
                top: 0,
                boxShadow: "inset 0 0 2.3rem 0.5rem #000",
                display: "flex",
                alignItems: "center",
                alignContent: "center",
                color: "#fff",
                borderTopLeftRadius: "inherit",
                borderTopRightRadius: "inherit",
                "@media (max-width: 575.98px)": {
                  "& + img": { width: "100% !important" },
                },
                "& .overlay-btn-wrapper": {
                  position: "relative",
                  zIndex: 3,
                  textAlign: "center",
                  width: "100%",
                },
                "&::before": {
                  zIndex: 2,
                  position: "absolute",
                  left: 0,
                  top: 0,
                  content: "\"\"",
                  width: "100%",
                  height: "100%",
                  transition: "all 0.2s ease-in-out",
                  background: "#000",
                  opacity: 0.75,
                },
              },
              "& .img-wrapper-overlay--visible": {
                visibility: "visible",
                opacity: 1,
                position: "relative",
                zIndex: 5,
              },
              "& .card-badges": { zIndex: 5 },
              "a&": {
                display: "block",
                overflow: "hidden",
                "&:hover .img-wrapper-overlay": { opacity: 1, visibility: "visible" },
              },
            }]}>
              <Box sx={[{ backgroundImage: imageSmallSrc ? 'url(' + imageSmallSrc + ')' : undefined, height: 325, display: 'flex', justifyContent: 'center', alignItems: 'center', }, { backgroundSize: "contain", backgroundPosition: "center", backgroundRepeat: "no-repeat" }]}>
                <Box component="img" src={imageSrc} alt="..." loading="lazy" sx={[strategyCompImgFluidSx, { borderRadius: '0.65rem' }, { flexShrink: 0, width: "100%" }]}/>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Card>
    </div>
  )

  const compImages = compact(slice(comp.images, 0, 5))

  return (
    <Box sx={{ display: 'flex', minWidth: 0, width: '100%' }}>
      <Box sx={[{ backgroundColor: cardBg, width: '100%' }, {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        minWidth: 0,
        backgroundColor: "#fff",
        borderRadius: "0.65rem",
        boxShadow: "0 0.46875rem 2.1875rem rgba(59, 62, 102, 0.03), 0 0.9375rem 1.40625rem rgba(59, 62, 102, 0.03), 0 0.25rem 0.53125rem rgba(59, 62, 102, 0.05), 0 0.125rem 0.1875rem rgba(59, 62, 102, 0.03)",
        "button&": { outline: "none" },
        wordWrap: "break-word",
        backgroundClip: "border-box",
        border: "0 solid rgba(79, 80, 98, 0.3)",
        "html[data-color-mode=\"dark\"] &": { backgroundColor: "#1e1e1e !important", color: "rgba(255, 255, 255, 0.87)" },
        transition: "all 0.2s ease-in-out !important",
        "&:hover": { boxShadow: "0 0.56875rem 3.3875rem rgba(59, 62, 102, 0.05), 0 0.9975rem 2.40625rem rgba(59, 62, 102, 0.07), 0 0.35rem 1.23125rem rgba(59, 62, 102, 0.05), 0 0.225rem 1.1875rem rgba(59, 62, 102, 0.09)", transform: "translateY(-15px)" },
        "&.card-box-hover:hover": { boxShadow: "0 0.56875rem 3.3875rem rgba(59, 62, 102, 0.05), 0 0.9975rem 2.40625rem rgba(59, 62, 102, 0.07), 0 0.35rem 1.23125rem rgba(59, 62, 102, 0.05), 0 0.225rem 1.1875rem rgba(59, 62, 102, 0.09)", transform: "translateY(0)" },
      }]}>
        <Box sx={[{ left: 8, right: 'auto', backgroundColor: 'transparent', boxShadow: 'transparent', }, {
          position: "absolute",
          right: "0.75rem",
          top: "0.75rem",
          zIndex: 2,
        }]}>
          <Grid container spacing={1} sx={{ textAlign: 'left' }}>
            {comp.saleDate && (
              <Grid>
                {/* <Box sx={{ backgroundColor: '#ff3f3d', color: 'white' }}>Sold {months[date.getMonth()] + ' ' + date.getFullYear()}</Box> */}
                <Box
                  component="div"
                  sx={compsSoldBadgeSx({
                    isPotential: comp.potential,
                    soldBeforeCreated:
                      createdAt2.getTime() > date.getTime(),
                  })}
                >
                  Sold{' '}
                  {months[date.getMonth()] + ' ' + date.getFullYear()}
                </Box>
              </Grid>
            )}
          </Grid>
        </Box>
        <Slider1 {...widgetsCarousels1B} sx={{ flexShrink: 0, width: "100%" }}>
          {isEmpty(compImages)
            ? renderImageSlide('/images/default_image.png')
            : map(compImages, (image) =>
                renderImageSlide(image.url, image.url_small),
              )}
        </Slider1>
        <Box sx={[{ left: 'auto', right: 8, backgroundColor: 'transparent', boxShadow: 'transparent', }, { position: "absolute", left: "1rem", top: "0.5rem" }]}>
          <Grid
            container
            spacing={1} sx={[strategyTextRightSx, { justifyContent: 'flex-end' }]}>
            {!props.shared && (
              <Grid>
                <IconButton
                  onClick={props.selectComp(comp._id)}
                  size="large"
                >
                  <Checkbox
                    checked={includes(props.selected, comp._id)} sx={{
                      height: 20,
                      width: 20,
                      backgroundColor: cardBg,
                      borderRadius: 0,
                    }}/>
                </IconButton>
              </Grid>
            )}
            <Grid
              onClick={props.shared ? null : () => openEdit(comp)}
            >
              <Avatar sx={{
                  height: 30,
                  width: 30,
                  backgroundColor: compMarkerColor(props.potential),
                  color: '#fff',
                }}>
                {props.index + 1}
              </Avatar>
            </Grid>
          </Grid>
        </Box>
        {/* <div>
          <Button variant="text">
            <FontAwesomeIcon icon={['far', 'square']} />
          </Button>
        </div> */}
        <CardContent
          onClick={props.shared ? null : () => openEdit(comp)}
        >
          <Grid container direction="column">
            <Grid>
              <Grid
                container
                wrap="wrap"
                sx={{
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  rowGap: 0.5,
                }}
              >
                <Grid size="auto" sx={{ minWidth: 0 }}>
                  <Typography sx={strategyPrice26Sx}>
                    {currencyFormat.format(comp.estval)}
                  </Typography>
                </Grid>
                <Grid size="auto" sx={{ minWidth: 0 }}>
                  <Typography sx={strategyFont16Sx}>
                    {comp.beds} bd | {comp.baths} ba |{' '}
                    {numberFormat.format(comp.sqft)} sqft |{' '}
                    {comp.year} yr
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid>
              <Grid
                container
                wrap="nowrap"
                sx={{
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Grid>
                  <Typography
                   
                    noWrap={true} sx={strategyFont16SemiboldSx}>
                    {comp.address}, {comp.city}, {comp.state}{' '}
                    {comp.zip}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid>
              <Typography sx={{ fontSize: "0.875rem !important" }}>
                Date Added: {createdAt}
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={{ fontSize: "0.875rem !important" }}>
                Last Sold Date:{' '}
                {comp.saleDate
                  ? new Date(comp.saleDate).toLocaleDateString(
                      'en-US',
                    )
                  : 'N/A'}
              </Typography>
            </Grid>
          </Grid>
          <Grid sx={strategyMarginTopBottom10Sx}>
            <Card sx={{ backgroundColor: metricsBg }}>
              <CardContent sx={strategyPad10Sx}>
                <Grid
                  container
                  direction="row"
                  sx={{
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: 1,
                    "& > *": { flex: "1 1 96px", minWidth: 0 },
                  }}
                >
                  <Grid>
                    <Grid
                      container
                      direction="column"
                      sx={{
                        alignItems: 'center',
                      }}
                    >
                      <Grid>
                        <Typography sx={{
                            whiteSpace: 'nowrap',
                            color: mutedLabel,
                            fontWeight: 600,
                          }}>
                          Adjustment
                        </Typography>
                      </Grid>
                      <Grid>
                        <Typography sx={{
                            whiteSpace: 'nowrap',
                            color: '#008bff',
                            fontWeight: 600,
                          }}>
                          {currencyFormat.format(
                            comp.estval *
                              (comp.priceAdjustment / 100),
                          )}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid>
                    <Grid
                      container
                      direction="column"
                      sx={{
                        alignItems: 'center',
                      }}
                    >
                      <Grid>
                        <Typography sx={{
                            whiteSpace: 'nowrap',
                            color: mutedLabel,
                            fontWeight: 600,
                          }}>
                          $/sqft
                        </Typography>
                      </Grid>
                      <Grid>
                        <Typography sx={{
                            whiteSpace: 'nowrap',
                            color: valueColor,
                            fontWeight: 600,
                          }}>
                          {comp.sqft
                            ? moneysqftFormat.format(
                                (comp.estval *
                                  (1 + comp.priceAdjustment / 100)) /
                                  comp.sqft,
                              )
                            : '-'}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid>
                    <Grid
                      container
                      direction="column"
                      sx={{
                        alignItems: 'center',
                      }}
                    >
                      <Grid>
                        <Typography sx={{
                            whiteSpace: 'nowrap',
                            color: mutedLabel,
                            fontWeight: 600,
                          }}>
                          Distance
                        </Typography>
                      </Grid>
                      <Grid>
                        <Typography sx={{
                            whiteSpace: 'nowrap',
                            fontWeight: 600,
                            color:
                              parseFloat(
                                merge(
                                  DEFAULT_PREFERENCES,
                                  activeOrg.preferences,
                                ).findComps.maxDistance,
                              ) < comp.distance && comp.potential
                                ? '#f4772e'
                                : valueColor,
                          }}>
                          {numberFormat.format(comp.distance)} miles
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid size={12} sx={strategyMarginBottomNeg30Sx}>
            Adjust Comp
          </Grid>
          <Grid
            size={{ md: 12 }}
           
            onClick={(event) => {
              event.stopPropagation()
            }} sx={strategyMarginTop5Sx}>
            <Slider
              color="#008bff"
              value={inputAdjustment}
              onChange={
              props.shared
              ? null
              : (event, value) => {
              onChangeSlider(event, value, 'priceAdjustment')
              }
              }
              onChangeCommitted={
              props.shared
              ? null
              : (event, value) => {
              onChangeSlider(
              event,
              value,
              'priceAdjustment',
              updateCompProperty,
              )
              }
              }
              marks={true}
              track={false}
              valueLabelDisplay="auto"
              min={-15}
              max={15}
              step={2.5}
              valueLabelFormat={(x) => `${x}%`} sx={[strategySliderWidthSx, { my: '1rem' }]}/>
          </Grid>
          {/* <Grid sx={{ marginTop: '-20px' }}>
            <Grid container direction='row' alignItems='center' justifyContent='space-between' wrap='nowrap'>
              <Grid>
                <Typography>Worse</Typography>
              </Grid>
              <Grid>
                <Typography>Same</Typography>
              </Grid>
              <Grid>
                <Typography>Better</Typography>
              </Grid>
            </Grid>
          </Grid> */}
        </CardContent>
      </Box>
    </Box>
  )
}

export default withSession(CenterPageCompsCardComponent)
